import React from 'react';
import { HeroSection } from './components/HeroSection';
import { VideoSection } from './components/VideoSection';
import { WhatIsSection } from './components/WhatIsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ConditionsSection } from './components/ConditionsSection';
import { TreatmentTimeline } from './components/TreatmentTimeline';
import { TreatmentFrequency } from './components/TreatmentFrequency';
import { SportsRecovery } from './components/SportsRecovery';
import { ScienceSection } from './components/ScienceSection';
import { FAQSection } from './components/FAQSection';
import { SafetySection } from './components/SafetySection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <main className="w-full min-h-screen bg-white overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <VideoSection data-id="element-2" />
      <WhatIsSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <ConditionsSection data-id="element-5" />
      <TreatmentTimeline data-id="element-6" />
      <TreatmentFrequency data-id="element-7" />
      <SportsRecovery data-id="element-8" />
      <ScienceSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <SafetySection data-id="element-11" />
      <FinalCTA data-id="element-12" />
    </main>;
}